import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["memberSelect", "sectorSelect", "coordinatorSelect"];

  connect() {
    console.log("TransferFormController connected");
    this.filterSectors();
    this.filterCoordinators();
  }

  filterSectors() {
    const selectedMemberId = this.memberSelectTarget.value;
    if (!selectedMemberId) {
      this.resetSectors();
      return;
    }

    const selectedOption = this.memberSelectTarget.selectedOptions[0];
    const memberSectorId = selectedOption.dataset.sectorId;

    Array.from(this.sectorSelectTarget.options).forEach((option) => {
      option.disabled = option.value === memberSectorId;
      option.hidden = option.value === memberSectorId;
    });
  }

  filterCoordinators() {
    const sectorId = this.sectorSelectTarget.value;
    if (!sectorId) {
      this.resetCoordinators();
      return;
    }

    const currentValue = this.coordinatorSelectTarget.value;

    fetch(`/sectors/${sectorId}/coordinators.json`)
      .then((res) => res.json())
      .then((members) => {
        this.coordinatorSelectTarget.innerHTML = `<option value="">Select Coordinator</option>`;
        members.forEach((m) => {
          const option = document.createElement("option");
          option.value = m.id;
          option.textContent = `${m.name_formal} - ${m.nickname}`;
          this.coordinatorSelectTarget.appendChild(option);
        });

        if (currentValue) {
          this.coordinatorSelectTarget.value = currentValue;
        }
      });
  }

  resetSectors() {
    Array.from(this.sectorSelectTarget.options).forEach((option) => {
      option.disabled = false;
      option.hidden = false;
    });
  }

  resetCoordinators() {
    this.coordinatorSelectTarget.innerHTML = `<option value="">Select Coordinator</option>`;
  }
}
